import { Box, Stack, Switch } from '@mui/material';
import { TransportFuelPipeSensorIcon } from 'app/icons';
import React from 'react';

import { paperProgressStatusStyle } from '../TabPanelConditionStyle';

const DRAIN_SENSOR_THRESHOLD = 700;

export const SensorStatusIndicators = ({
  hasDrainSensor,
  hasFuelSensor,
  drainSensorValue,
  fuelSensorValue,
  isDefaultDrain,
  isDefaultFuel,
  hasDevice,
}) => {
  if (!hasDrainSensor && !hasFuelSensor) {
    return null;
  }

  return (
    <Stack direction='column' className='MuiPaperProgress-status' sx={paperProgressStatusStyle}>
      {hasDrainSensor && (
        <Box>
          <DrainSensorSwitch value={drainSensorValue} isDefault={isDefaultDrain} hasDevice={hasDevice} />
        </Box>
      )}
      {hasFuelSensor && (
        <Box>
          <FuelSensorIcon value={fuelSensorValue} isDefault={isDefaultFuel} hasDevice={hasDevice} />
        </Box>
      )}
    </Stack>
  );
};

const DrainSensorSwitch = ({ value, isDefault, hasDevice }) => {
  if (!hasDevice || isDefault) {
    return <Switch disabled size='small' onChange={() => {}} checked={false} />;
  }

  const isChecked = value >= DRAIN_SENSOR_THRESHOLD;
  return <Switch size='small' onChange={() => {}} checked={isChecked} />;
};

// eslint-disable-next-line no-unused-vars
const FuelSensorIcon = ({ value, isDefault, hasDevice }) => {
  if (!hasDevice || value === -1) {
    return <TransportFuelPipeSensorIcon viewBox='0 0 16 24' color='disabled' />;
  }

  const color = value > 0 ? 'fuelIn' : 'fuelOut';
  return <TransportFuelPipeSensorIcon viewBox='0 0 16 24' color={color} />;
};
